import React, { useState } from "react";
import styled from "styled-components";

import { getS3URL } from "@examspark/common";
import { User } from "@examspark/types";

const Styled = styled.div<AvatarProps>`
  position: relative;
  box-sizing: border-box;
  color: #fff;
  display: flex !important;
  align-items: center;
  background-color: #ccc;
  box-sizing: border-box;
  border-radius: 100%;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: solid 1px #ddd;
  box-shadow: inset 0 0 0 1px #fff;

  ${(props) =>
    props.borderColor &&
    `
    border-color: ${props.borderColor};
  `}

  img {
    max-width: 100%;
    ${(props) => {
      if (props.size) {
        return `border-radius: 100%`;
      }
    }}
  }
`;

const Initials = styled.div<{
  size: number;
}>`
  margin: 0 auto;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
  font-size: ${(props) => {
    if (props.size) {
      return props.size * 0.45 + "px";
    } else {
      return "1em";
    }
  }};
`;

type AvatarProps = {
  size?: number | string;
  user?: User | null;
  borderColor?: string;
  awsconfig?: {
    aws_user_files_s3_bucket: string;
  };
};

const Avatar = (props: AvatarProps) => {
  const [size] = useState(props.size || 36);
  const { awsconfig } = props;
  const bucket = awsconfig?.aws_user_files_s3_bucket;
  let sub, hash, src;
  if (!props.user) return null;
  if (!props?.user?.id) return null;

  if (props?.user?.avatarHash && bucket) {
    sub = props.user.id;
    hash = props.user.avatarHash;
    src = getS3URL(awsconfig, `public/avatars/${sub}/avatar-500s.png?${hash}`);
  }

  return (
    <Styled size={size} {...props}>
      {props.user && src && (
        <img
          src={src}
          alt="User Avatar"
          title={`${props.user.firstName} ${props.user.lastName}`}
        />
      )}
      {props.user && !src && (
        <Initials
          title={`${props.user.firstName} ${props.user.lastName}`}
          size={Number(size)}
        >
          {(props.user.firstName || "").substring(0, 1) +
            (props.user.lastName || "").substring(0, 1)}
        </Initials>
      )}
      {/* <Marker /> */}
    </Styled>
  );
};
export default Avatar;
